import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './CategoryDetail.css';

function CategoryDetail() {
  const { slug } = useParams();
  const [category, setCategory] = useState(null);
  const [pros, setPros] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    Promise.all([
      fetch(`/api/categories/${slug}`).then(res => res.json()),
      fetch(`/api/categories/${slug}/professionnels`).then(res => res.json())
    ])
    .then(([catData, prosData]) => {
      setCategory(catData);
      setPros(prosData);
      setLoading(false);
    })
    .catch(err => {
      console.error('Erreur:', err);
      setLoading(false);
    });
  }, [slug]);

  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  if (!category) {
    return (
      <div className="error-page">
        <h1>404</h1>
        <p>Categorie non trouvee</p>
        <Link to="/categories" className="btn btn-primary">Voir toutes les categories</Link>
      </div>
    );
  }

  return (
    <div className="category-detail-page">
      <Helmet>
        <title>{category.nom} | Annuaire des Pros - E-Shop Pro Paris</title>
        <meta name="description" content={`Decouvrez les professionnels ${category.nom} qui nous font confiance. ${category.description}`} />
        <link rel="canonical" href={`https://annuaire.e-shop-pro.fr/categorie/${slug}`} />
      </Helmet>
      
      {/* Hero */}
      <section className="category-hero">
        <div className="container">
          <div className="category-hero-icon">{category.icone}</div>
          <h1>{category.nom}</h1>
          <p>{category.description}</p>
          <nav className="breadcrumb">
            <Link to="/">Accueil</Link>
            <span>/</span>
            <Link to="/categories">Categories</Link>
            <span>/</span>
            <span>{category.nom}</span>
          </nav>
        </div>
      </section>
      
      {/* Pros List */}
      <section className="pros-section">
        <div className="container">
          <p className="pros-count">
            {pros.length} professionnel{pros.length > 1 ? 's' : ''} dans cette categorie
          </p>
          
          {pros.length > 0 ? (
            <div className="pros-grid">
              {pros.map(pro => (
                <Link to={`/pro/${pro.slug}`} key={pro.id} className="pro-card">
                  <div className="pro-card-image">
                    {pro.site_cree_par_nous && (
                      <span className="pro-card-badge">Cree par E-Shop Pro</span>
                    )}
                  </div>
                  <div className="pro-card-content">
                    <h3>{pro.nom}</h3>
                    <div className="pro-card-location">
                      <span>📍</span>
                      <span>{pro.ville}</span>
                    </div>
                    <p className="pro-card-description">{pro.description_courte}</p>
                    <div className="pro-card-footer">
                      <span className="pro-card-link">
                        Voir le profil
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M5 12h14M12 5l7 7-7 7"/>
                        </svg>
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="empty-state">
              <div className="empty-state-icon">🔍</div>
              <h2>Aucun professionnel pour le moment</h2>
              <p>Nous travaillons a ajouter des professionnels dans cette categorie.</p>
              <Link to="/contact" className="btn-cta">Vous etes dans ce secteur ?</Link>
            </div>
          )}
        </div>
      </section>
      
      {/* CTA */}
      <section className="category-cta">
        <div className="container">
          <h2>Vous etes professionnel en {category.nom} ?</h2>
          <p>Rejoignez notre annuaire et boostez votre visibilite en ligne.</p>
          <Link to="/contact" className="btn-cta">Contactez-nous</Link>
        </div>
      </section>
    </div>
  );
}

export default CategoryDetail;
